import { Link } from "react-router-dom";
import { CalendarDays, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../../i18n";
import { useAuth } from "../../../context/AuthContext";
import { api } from "../../../lib/api";
import { PageHead, Panel, btnGhost } from "../../../components/common/Page";
import { RoleBadge } from "../../../components/common/RoleBadge";
import { LangSwitch } from "../../../components/common/LangSwitch";

const Row = ({ label, children, id }) => (
  <div className="flex flex-wrap items-center gap-2 border-b border-slate-100 py-3 text-sm last:border-0">
    <span className="w-28 text-slate-500">{label}</span><span className="min-w-0 flex-1 break-words font-medium text-navy" data-testid={id}>{children}</span>
  </div>
);

export default function MyAccount() {
  const { t } = useI18n();
  const { user } = useAuth();
  const reset = () => api.post("/auth/forgot-password", { email: user.email }).then(() => toast.success(t("snav.me.sent"))).catch(() => toast.error(t("common.error")));
  return (
    <div className="max-w-2xl space-y-5" data-testid="my-account-page">
      <PageHead title={t("snav.me.title")} sub={t("snav.me.sub")} />
      <Panel>
        <Row label={t("snav.me.name")} id="me-name">{user.name}</Row>
        <Row label={t("snav.me.email")} id="me-email">{user.email}</Row>
        <Row label={t("snav.me.roles")} id="me-roles"><span className="flex flex-wrap gap-1">{user.roles.map((r) => <RoleBadge key={r} role={r} />)}</span></Row>
        <Row label={t("snav.me.lang")}><LangSwitch /></Row>
      </Panel>
      <div className="flex flex-wrap gap-2">
        <Link to="/staff/hr?tab=timesheet" className={btnGhost} data-testid="me-hr-link"><CalendarDays className="h-4 w-4" />{t("snav.me.hr")}</Link>
        <button type="button" onClick={reset} className={btnGhost} data-testid="me-password"><KeyRound className="h-4 w-4" />{t("snav.me.password")}</button>
      </div>
      <p className="text-xs text-slate-500">{t("snav.me.passwordSub")}</p>
    </div>
  );
}
